import request from './request';
const api = {
    indexSwiper: (params) => {
        return request.get("guild/api/swiper", params);
    },
    indexPuHui: (params) => {
        return request.get("guild/api/normal_safeguard", params);
    },
    indexHuiFei: (params) => {
        return request.get("guild/api/card_safeguard", params);
    },
    indexQuanYi: (params) => {
        return request.get("guild/api/card_benefits", params);
    },
    indexHuiYUanRi: (params) => {
        return request.get("guild/api/member_day", params);
    },
    indexHuoDong: (params) => {
        return request.get("guild/api/special_product", {params:params});
    }

}

export default api